import {
  EventName,
  type KindnessChallengeEntrySubmittedProperties
} from '../types/events';

export function trackKindnessChallengeEntrySubmitted(
  properties: KindnessChallengeEntrySubmittedProperties
) {
  return {
    event: EventName.KindnessChallengeEntrySubmitted,
    properties
  };
}
